module.exports = __webpack_public_path__ + "8a417895d93560dba7a2d5db0174efa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_catalog_light.png
// module id = 878
// module chunks = 0 1